
// Import useEffect for side effects and useLocation for route info
import { useEffect } from "react";
import { useLocation } from "react-router-dom";


/**
 * ScrollToTop component for scrolling to the top or to a hash target on route change.
 *
 * - On route change, scrolls to top unless a hash is present.
 * - If a hash is present, scrolls smoothly to the element with the corresponding id.
 * - Returns null (no UI rendered).
 */
function ScrollToTop() {
  // Get current pathname and hash from the router
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If no hash, scroll to top of the page
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    // If hash exists, scroll to the element with the corresponding id
    const targetId = hash.replace("#", "");
    const target = document.getElementById(targetId);

    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [pathname, hash]);

  // No UI rendered
  return null;
}


// Export the ScrollToTop component as default
export default ScrollToTop;
